import { render, staticRenderFns } from "./TicketsMatch.component.vue?vue&type=template&id=1edc7198"
import script from "./TicketsMatch.component.vue?vue&type=script&lang=js"
export * from "./TicketsMatch.component.vue?vue&type=script&lang=js"
import style0 from "./TicketsMatch.component.vue?vue&type=style&index=0&id=1edc7198&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports